import cx from 'classnames'

import '@/components/Review/CustomerReview/CustomerReview.scss'
import ReviewStars from '@/components/Review/ReviewStars'
import { ReviewType } from '@/types/review'

export default function CustomerReview({ review }: { review: ReviewType }) {
  return (
    <>
      <div className={cx('c-review-customerReview')}>
        <div className={cx('c-review-customerReview-header')}>
          <div className={cx('c-review-customerReview__icon')}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
              <g id="レイヤー_2" data-name="レイヤー 2">
                <g id="design">
                  <circle
                    cx="45"
                    cy="45"
                    r="42.5"
                    style={{
                      fill: 'none',
                      stroke: '#3e3029',
                      strokeLinecap: 'round',
                      strokeLinejoin: 'round',
                      strokeWidth: '5px',
                    }}
                  />
                  <path
                    d="M63.43,36a18.53,18.53,0,0,0-37.06,0c0,6.2,1.88,11.69,6.56,15.05-8,5.3-11.46,15.23-13.19,27.74,6.53,5,16.42,8.7,25.21,8.7,8.53,0,18-3.49,25.29-8.68-1.55-12.67-4.78-22.78-13.17-28C61.58,47.46,63.43,42.08,63.43,36Z"
                    style={{
                      fill: 'none',
                      stroke: '#3e3029',
                      strokeLinecap: 'round',
                      strokeLinejoin: 'round',
                      strokeWidth: '5px',
                    }}
                  />
                </g>
              </g>
            </svg>
          </div>
          <p className={cx('c-review-customerReview__profile', 'u-font-yu-min')}>
            <span className={cx('c-review-customerReview__nickname', 'u-font-yu-min')}>{review.nickname}</span>
            <span className={cx('c-review-customerReview__age', 'u-font-yu-min')}>{review.ageRangeLabel}</span>
          </p>
        </div>
        <div className={cx('c-review-customerReview__stars')}>
          <ReviewStars reviewRating={review.totalScore} scale={16} />
        </div>
        <div className={cx('c-review-customerReview__title', 'u-font-yu-min')}>{review.title}</div>
        <div className={cx('c-review-customerReview__text', 'u-font-yu-go')}>{review.text}</div>
        <div className={cx('c-review-customerReview__date', 'u-font-yu-go')}>{review.createdAt}</div>
      </div>
    </>
  )
}
